<template>
 <div class="fc-page mg-page rp-page rp-day_class_revenue_list">
  <nav aria-label="面包屑"><v-breadcrumbs :items="breadcrumbs" divider="/" class="mg-breadcrumb" /></nav>
  <header class="fc-heading"><div><h1>每日消课收入报表</h1><p>按日期查看消课课时、学费扣减与消课收入</p></div><span class="rp-heading-symbol" aria-hidden="true"><v-icon size="25" color="#d9363e">mdi-chart-box-outline</v-icon></span></header>
  <section class="fc-filters" aria-label="报表筛选"><div class="fc-filter-heading"><h3>筛选条件</h3><span>按日期查询每日统计</span></div><form @submit.prevent="getTableDataList"><div class="fc-filter-grid rp-date-grid">
   <div class="fc-filter-cell"><v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto"><template v-slot:activator="{on,attrs}"><v-text-field v-model="query.start" label="开始日期" readonly v-bind="attrs" v-on="on" dense clearable outlined hide-details color="#d9363e" /></template><v-date-picker v-model="query.start" @input="menu1=false" no-title scrollable locale="zh-cn" color="#d9363e" /></v-menu></div>
   <div class="fc-filter-cell"><v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto"><template v-slot:activator="{on,attrs}"><v-text-field v-model="query.end" label="结束日期" readonly v-bind="attrs" v-on="on" dense clearable outlined hide-details color="#d9363e" /></template><v-date-picker v-model="query.end" @input="menu2=false" no-title scrollable locale="zh-cn" color="#d9363e" /></v-menu></div>
  </div><div class="fc-filter-bottom"><span>设置日期范围后点击查询</span><div class="fc-filter-actions"><v-btn type="submit" color="#d9363e" dark depressed :loading="query.loading"><v-icon left size="17">mdi-magnify</v-icon>查询</v-btn></div></div></form></section>
  <section class="rp-page-totals" aria-label="本页统计"><div class="rp-totals-note"><strong>本页统计</strong><span>仅统计当前页记录</span></div><div class="rp-total"><span>消课时数</span><div><strong>{{sumTotalReduceHours}}</strong><small>课时</small></div></div><div class="rp-total"><span>扣学费金额</span><div><strong>{{sumTotalReduceTuitionFee}}</strong><small>元</small></div></div><div class="rp-total"><span>消课收入</span><div><strong>{{sumTotalRevenueAmount}}</strong><small>元</small></div></div></section>
  <section class="fc-records"><div class="fc-list-heading"><h3>每日统计明细</h3><span class="fc-count">共 <strong>{{data.total}}</strong> 条</span></div>
   <v-data-table :headers="data.headers" :items="data.list" :loading="query.loading" class="fc-table mg-table rp-table" :mobile-breakpoint="0" disable-pagination hide-default-footer item-key="id" loading-text="正在加载，请稍候…" no-data-text="暂无符合条件的记录">
   </v-data-table><div class="fc-pagination"><div class="fc-page-size"><v-select :items="[10,20,50,100]" @change="handleSizeChange" dense hide-details label="每页数量" outlined v-model="query.size" color="#d9363e" /><span>条 / 页</span><span class="fc-total">共 {{data.total}} 条</span></div><v-pagination v-if="Math.ceil(data.total/query.size)>0" :length="Math.ceil(data.total/query.size)" @input="handleCurrentChange" :total-visible="7" v-model="query.page" color="#d9363e" /></div></section>
 </div>
</template>

<script>
	import utils from "../../../config/utils"

	export default {
		name: "day-class-revenue-list",
		data() {
			return {
				menu1: false, // 开始时间菜单
				menu2: false, // 结束时间菜单
				breadcrumbs: [{
						text: '首页',
						disabled: false,
						href: "/"
					},
					{
						text: '数据报表',
						disabled: true
					},
					{
						text: '日消课收入统计',
						disabled: true
					},
				],
				shopId:"",
				data: {
					total: 0,
					headers: [
						{
							text: '校区',
							value: 'shopName',
							sortable: false
						},
						{
							text: '日期',
							value: 'bizDate',
							sortable: false
						},
						{
							text: '扣课时数',
							value: 'reduceClassHours',
							sortable: false
						},
						{
							text: '扣学费金额',
							value: 'reduceTuitionFee',
							sortable: false
						},
						{
							text: '消课收入',
							value: 'recordRevenueAmount',
							sortable: false
						},
					],
					list: [],
				},
				query: {
					loading: false,
					page: 1,
					size: 20,
					start: "",
					end: "",
				},
			}
		},
		created() {
			this.shopId = utils.getCurrentShopId();
			this.getTableDataList();
		},
		computed:{
			// 总缴费汇总
			sumTotalRevenueAmount(){
				let result = 0;
				if(this.data.list){
					this.data.list.forEach((item,index)=>{
						result = result+ parseFloat(item.recordRevenueAmount);
					})
				}
				return result.toFixed(2);
			},
			sumTotalReduceHours(){
				let result = 0;
				if(this.data.list){
					this.data.list.forEach((item,index)=>{
						result = result+ parseInt(item.reduceClassHours);
					})
				}
				return result;
			},
			sumTotalReduceTuitionFee(){
				let result = 0;
				if(this.data.list){
					this.data.list.forEach((item,index)=>{
						result = result+ parseInt(item.reduceTuitionFee);
					})
				}
				return result;
			}
			
		},
		methods: {
			handleSizeChange(size) {
				this.query.size = size;
				this.query.page = 1;
				this.getTableDataList();
			},
			handleCurrentChange(page) {
				this.query.page = page;
				this.getTableDataList();
			},
			
			getTableDataList() {
				const that = this;
				this.query.loading = true;


				let url = `/report/day/class/revenue/list/page/${that.query.page - 1}/size/${that.query.size}?v=1`;
				if (this.query.start) {
					url += "&start=" + this.query.start;
				}
				if (this.query.end) {
					url += "&end=" + this.query.end;
				}
				if (this.shopId) {
					url += "&shopId=" + this.shopId;
				}
				
				
				this.axios.get(url).catch(()=>{
					console.log("=============api catch=============");
					return;
				}).then(response => {
					that.query.loading = false;
					
					if (!response){
						that.$noty.error("获取数据失败")
						return;
					}
				
					if (response.data["code"] === 200) {
						that.data.list = response.data["data"]["list"] ? response.data["data"]["list"] : [];
						that.data.total = response.data["data"]["count"];
						return
					}
				
					that.$noty.error("获取失败：" + response.data["message"]);
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
@import "../../../assets/styles/reports-management.scss";
</style>
